import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";

export class PlanningDefaultDraftSelectListComponent implements IController {
  selectedId: string;
  excludeIds: string[];
  branchIds: string[];
  onChange: Function;

  private planningTemplatesDefaultDraftRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private excludeKeys: any;

  /* @ngInject */
  constructor(private $log, private $planningTemplatesDefaultDraft, private $infiniteScroll) {
  }

  $onInit() {
    this.planningTemplatesDefaultDraftRef = this.$planningTemplatesDefaultDraft();
    this.loadLimit = 20;

    this.planningTemplatesDefaultDraftRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.planningTemplatesDefaultDraftRef, this.loadLimit, {getFullData: true});
  }

  $onChanges(changes) {
    if (changes.excludeIds) {
      this.excludeKeys = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludeKeys[id] = true;
      })
    }
  }

  submitQuery(query) {
    this.queryString = query;
    this._reload();
  }

  private _reload() {
    this.planningTemplatesDefaultDraftRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.queryString,
      branchIds: this.branchIds
      // sort: 'name,asc'
    };
  }
}

angular
  .module('bringoz.admin.planning')
  .component('planningDefaultDraftSelectList', {
    bindings: {
      selectedId: '<',
      excludeIds: '<?',
      branchIds: '<?',
      onChange: '&'
    },
    template: require('./planning-default-draft-select-list.html').default,
    controller: PlanningDefaultDraftSelectListComponent
  });
